const iconPath = '/assets/img/logo_100.png';
const iconImpairedPath = '/assets/img/logo_100.png';

export const metaTagsData = {
  '/': {
    title: 'Портал открытых данных Правительства Москвы',
    description: 'Портал открытых данных Правительства Москвы является первым порталом открытых данных в России и был запущен для широкого круга пользователей 29 января 2013 года. На данный момент на портале опубликовано более 1000 наборов данных и справочников, в которых представлены сведения по различным направлениям: от объектов городской инфраструктуры до расписаний ближайших мероприятий, проводимых в городе Москва.',
    image: iconPath,
  },
  '/terms': {
    title: 'Условия использования | Портал открытых данных Правительства Москвы',
    description: 'Все материалы портала data.mos.ru являются открытыми данными в соответствии с требованием постановления Правительства РФ N 583 от 10 июля 2013 г. и могут быть воспроизведены в любых средствах массовой информации в информационно–телекоммуникационной сети Интернет или на любых иных носителях без каких-либо ограничений по объему и срокам публикации',
    image: iconPath,
  },
  '/documents': {
    title: 'Документация | Портал открытых данных Правительства Москвы',
    description: 'Официальные документы о размещении открытых данных и работе с ними',
    image: iconPath,
  },
  '/globalsearch': {
    title: 'Глобальный поиск | Портал открытых данных Правительства Москвы',
    description: 'Глобальный поиск по всем наборам данных, опубликованных на Портале открытых данных Правительства Москвы',
    image: iconPath,
  },
  '/opendata': {
    title: 'Наборы данных | Портал открытых данных Правительства Москвы',
    description: 'Список наборов данных, размещённых на Портале открытых данных Правительства Москвы',
    image: iconPath,
  },
  '/opendata/id': {
    title: 'Портал открытых данных Правительства Москвы',
    description: '',
    image: iconPath,
  },
  '/opendata/id/map': {
    title: 'Карта | Портал открытых данных Правительства Москвы',
    description: '',
    image: iconPath,
  },
  '/opendata/id/passport': {
    title: 'Паспорт | Портал открытых данных Правительства Москвы',
    description: '',
    image: iconPath,
  },
  '/opendata/id/description': {
    title: 'Описание | Портал открытых данных Правительства Москвы',
    description: '',
    image: iconPath,
  },
  '/opendata/appeals': {
    title: 'Обращение по содержимому набора данных | Портал открытых данных Правительства Москвы',
    description: 'Сообщите органам исполнительной власти Москвы о некорректном содержании набора данных',
    image: iconPath,
  },
  '/developers': {
    title: 'Кабинет разработчика | Портал открытых данных Правительства Москвы',
    description: 'Информация необходимая для настройки инфообмена между Порталом открытых данных Правительства Москвы и другими информационными системами посредством API',
    image: iconPath,
  },
  '/developers/documentation': {
    title: 'Документация API | Портал открытых данных Правительства Москвы',
    description: 'Описание всех доступных API-методов Портала открытых данных Правительства Москвы, примеры запросов и ответов для правильной настройки инфообмена',
    image: iconPath,
  },
  '/developers/useApi': {
    title: 'Попробовать API | Портал открытых данных Правительства Москвы',
    description: 'Знакомство с возможностями API-методов Портала открытых данных Правительства Москвы, изучение их спецификации на практике без получения уникального API-ключа',
    image: iconPath,
  },
  '/developers/statistics': {
    title: 'Статистика использования API-ключа | Портал открытых данных Правительства Москвы',
    description: 'Статистика запросов к Порталу открытых данных Правительства Москвы в разрезе уникального API-ключа пользователя',
    image: iconPath,
  },
  '/information-placement': {
    title: 'Заявка на размещение информации о приложении на портале | Портал открытых данных Правительства Москвы',
    description: 'Отправьте заявку на размещение информации о Вашем приложении на главной странице Портала открытых данных Правительства Москвы',
    image: iconPath,
  },
  '/personal-profile/profile': {
    title: 'ЛК пользователя | Профиль | Портал открытых данных Правительства Москвы',
    description: 'Профиль пользователя в личном кабинете Портала открытых данных Правительства Москвы',
    image: iconPath,
  },
  '/personal-profile/interests': {
    title: 'ЛК пользователя | Интересы | Портал открытых данных Правительства Москвы',
    description: 'Настройка интересов пользователя в личном кабинете Портала открытых данных Правительства Москвы',
    image: iconPath,
  },
  '/personal-profile/notification': {
    title: 'ЛК пользователя | Уведомления | Портал открытых данных Правительства Москвы',
    description: 'Уведомления пользователя в личном кабинете Портала открытых данных Правительства Москвы',
    image: iconPath,
  },
  '/visually-impaired/dataset': {
    title: 'Портал открытых данных Правительства Москвы | Версия для слабовидящих',
    description: 'Специальная версия сайта Портала открытых данных Правительства Москвы, предназначенная для людей с нарушениями зрения',
    image: iconImpairedPath,
  },
  '/visually-impaired/dataset/id/datasetItems': {
    title: 'Портал открытых данных Правительства Москвы | Версия для слабовидящих',
    description: '',
    image: iconImpairedPath,
  },
  '/visually-impaired/dataset/id/map': {
    title: 'Карта | Портал открытых данных Правительства Москвы | Версия для слабовидящих',
    description: '',
    image: iconImpairedPath,
  },
  '/visually-impaired/dataset/id/passport': {
    title: 'Паспорт | Портал открытых данных Правительства Москвы | Версия для слабовидящих',
    description: '',
    image: iconImpairedPath,
  },
  '/visually-impaired/dataset/id/description': {
    title: 'Описание | Портал открытых данных Правительства Москвы | Версия для слабовидящих',
    description: '',
    image: iconImpairedPath,
  },
  '/visually-impaired/apps': {
    title: 'Приложения | Портал открытых данных Правительства Москвы | Версия для слабовидящих',
    description: '',
    image: iconImpairedPath,
  },
  '/visually-impaired/news': {
    title: 'Новости | Портал открытых данных Правительства Москвы | Версия для слабовидящих',
    description: '',
    image: iconImpairedPath,
  },
  '/visually-impaired/information': {
    title: 'Информация | Портал открытых данных Правительства Москвы | Версия для слабовидящих',
    description: '',
    image: iconImpairedPath,
  },
  '/visually-impaired/information/aboutThePortal': {
    title: 'Информация | Портал открытых данных Правительства Москвы | Версия для слабовидящих',
    description: '',
    image: iconImpairedPath,
  },
  '/visually-impaired/information/termOfUse': {
    title: 'Информация | Портал открытых данных Правительства Москвы | Версия для слабовидящих',
    description: '',
    image: iconImpairedPath,
  },
  '/visually-impaired/information/documents': {
    title: 'Информация | Портал открытых данных Правительства Москвы | Версия для слабовидящих',
    description: '',
    image: iconImpairedPath,
  },
  '/impaired-appeals/appeals': {
    title: 'Обращение по содержимому набора данных | Портал открытых данных Правительства Москвы | Версия для слабовидящих',
    description: '',
    image: iconImpairedPath,
  },
};
